import React from 'react';

import ProductWarnTooltip from './ProoductWarnTooltip';
import Tag from '../../../components/FormInputTag/Tag';
import styles from '../RequestReport.module.css';

export default function CompetitiveProduct({
  product,
  deleteProduct,
  displayMode,
}) {
  const nameId = `${product.name}-${product.id}`;
  return (
    <tr key={product.id} displayMode={displayMode}>
      <td className={styles.colName}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Tag
            readOnly={displayMode}
            label={product.name}
            onDelete={() => deleteProduct(product.name)}
            name={nameId}
            className="name"
            data-idx={product.id}
          />
          <ProductWarnTooltip
            condition={product.textureReviewsLowerBound < 6}
            message="Product has insufficient data for texture analysis"
          />
          <ProductWarnTooltip
            condition={product.category === null}
            message="Product has no category for analysis"
          />
        </div>
      </td>
    </tr>
  );
}
